import { expand } from 'uri-template-lite';
import { Page, PageRequestParams } from '../../common/queryClient';
import { apiClient } from '../../common/ApiClient';
import { createApiQueryHook } from '../../common/queryClient/createApiQueryHook';
import { DataSubjectUrl } from './DataSubjectUrl';
import {
  DataSubjectChangeHistoryDto,
  DataSubjectHistorySortField,
} from '../types';

export interface DataSubjectHistoryFilters {
  id: number;
}

type DataSubjectHistoryQueryParams = DataSubjectHistoryFilters &
  PageRequestParams<DataSubjectHistorySortField>;

function cleanSortOrder(params?: DataSubjectHistoryQueryParams) {
  const { sort, ...rest } = params ?? {};

  if (!sort) {
    return { ...params };
  }

  if (Array.isArray(sort)) {
    return {
      ...rest,
      sort: sort.map((sortAttr) =>
        sortAttr.replace('classifierId', 'field.name')
      ),
    };
  }

  return {
    ...rest,
    sort: sort.replace('classifierId', 'field.name'),
  };
}

const getDataSubjects = (params?: DataSubjectHistoryQueryParams) =>
  apiClient
    .get<Page<DataSubjectChangeHistoryDto>>(
      expand(DataSubjectUrl.DATASUBJECT_HISTORY, cleanSortOrder(params))
    )
    .then((response) => response.data);

export const useDataSubjectHistoryQuery = createApiQueryHook(
  ['dataSubjectHistory'],
  getDataSubjects
);
